export const convertAnswer = (str) => {
  if(!str) return str;
  // Если входные данные - массив
  if (Array.isArray(str)) {
    return str.join(', ');
  }
  
  // Если входные данные - строка, которая может быть JSON-массивом
  if (typeof str === 'string') {
    try {
      const parsed = JSON.parse(str);
      if (Array.isArray(parsed)) {
        return parsed.join(', ');
      }
    } catch (e) {
      // Если не удалось распарсить как JSON, вернем строку как есть
    }
    return str;
  }
  
  // Для чисел и других типов (не массивов и не строк) возвращаем как есть
  return str;
}